export const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || 8000
export const BACKEND_WS_PORT = process.env.REACT_APP_BACKEND_WS_PORT || 8000
export const BACKEND_PROTO =
  process.env.REACT_APP_BACKEND_SECURE === 'true' ? 'https' : 'http'
export const BACKEND_WS_PROTO =
  process.env.REACT_APP_BACKEND_SECURE === 'true' ? 'wss' : 'ws'
export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'localhost'
export const ANALYTICS_ID = process.env.ANALYTICS_ID || ''

export const REACT_APP_ANALYTICS_ID =
  process.env.REACT_APP_ANALYTICS_ID || 'localhost'

// // Export premade URL
export const BACKEND_BASE = `${BACKEND_PROTO}://${BACKEND_HOST}:${BACKEND_PORT}/`
export const BACKEND_URL = `${BACKEND_PROTO}://${BACKEND_HOST}:${BACKEND_PORT}/api`
export const BACKEND_WS_URL = `${BACKEND_WS_PROTO}://${BACKEND_HOST}:${BACKEND_WS_PORT}/wsapi`



// WEBPACK FOOTER //
// ./src/constants.ts